import styled from 'styled-components';

export const VirtualBackgroundsButtonWrapper = styled.div`
    margin-top: 8px;
`;

export const NoPermissionHint = styled.div`
    display: block;
    margin-top: 2px;
    height: 16px;
`;
